<template>
  <main class="admin-page">
    <header class="page-heading"><div><div class="page-kicker">CONSENT ARCHIVE</div><h1 class="page-title">授权协议</h1><p class="page-lead">按项目留存肖像、素材及制作授权的不可变文本快照。</p></div><el-button icon="el-icon-refresh" @click="load">刷新</el-button></header>
    <section class="surface"><el-table :data="list" empty-text="暂无授权协议记录">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="order_no" label="订单号" width="180" />
      <el-table-column prop="demand_id" label="需求ID" width="90" />
      <el-table-column prop="user_id" label="用户ID" width="90" />
      <el-table-column prop="agreement_version" label="版本" width="160" />
      <el-table-column prop="content_hash" label="内容哈希" min-width="260" />
      <el-table-column prop="signed_at" label="签署时间" width="180" />
      <el-table-column label="协议文本" width="120">
        <template slot-scope="{ row }">
          <el-button size="mini" @click="show(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table></section>

    <el-dialog title="协议文本快照" :visible.sync="dialogVisible" width="720px">
      <pre class="agreement-text">{{ currentText }}</pre>
    </el-dialog>
  </main>
</template>

<script>
import request from '../api/request'
import ElDialog from 'element-ui/lib/dialog'
import ElTable from 'element-ui/lib/table'
import ElTableColumn from 'element-ui/lib/table-column'

export default {
  components: { ElDialog, ElTable, ElTableColumn },
  data() {
    return {
      list: [],
      dialogVisible: false,
      currentText: ''
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      const res = await request.get('/agreements')
      this.list = res.list
    },
    show(row) {
      this.currentText = row.content_snapshot
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.agreement-text {
  white-space: pre-wrap;
  line-height: 1.6;
}
</style>
